// extracted by mini-css-extract-plugin
module.exports = {"clipTextOverflow":"TableLoading_clipTextOverflow__3JinC"};